export default class OrganizationService {
  /* @ngInject */
  constructor($rootScope, SecurityManager) {
    this.$rootScope = $rootScope;
    this.SecurityManager = SecurityManager;
  }

  async updateOrganization(organization) {
    await organization.update();
    await this.SecurityManager.refreshUser();

    return organization;
  }

  async createOrganization(organization) {
    await organization.create();
    await this.SecurityManager.refreshUser();

    return organization;
  }

  async updateCurrency(organization, updateTariffs) {
    await this.$rootScope.organization.updateCurrency(
      organization.settings.currency,
      updateTariffs
    );
  }

  async updateRegionalSettings(organization, updateTariffs) {
    await this.$rootScope.organization.updateRegionalSettings(
      organization,
      updateTariffs
    );
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async removeUser(userId) {
    await this.$rootScope.organization.removeUser(userId);
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async updateMetadataLogo(metadata) {
    await this.$rootScope.organization.updateMetadataLogo(metadata);
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async editQuoteNumber(quoteNumberId, nextNumber, isDefault) {
    await this.$rootScope.organization.editQuoteNumber(
      quoteNumberId,
      nextNumber,
      isDefault
    );
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async createTax(name, percentage) {
    await this.$rootScope.organization.createTax(name, percentage);
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async editTax(taxId, name, percentage, isDefault) {
    await this.$rootScope.organization.editTax(
      taxId,
      name,
      percentage,
      isDefault
    );
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async deleteTax(taxId) {
    await this.$rootScope.organization.deleteTax(taxId);
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async verifyCustomDomain() {
    await this.$rootScope.organization.verifyCustomDomain();
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }

  async createCustomFields(customFields) {
    return this.$rootScope.organization.createCustomFields(customFields);
  }

  async deleteCustomField(customFieldId) {
    return this.$rootScope.organization.deleteCustomField(customFieldId);
  }

  async toggleAdmin(userId) {
    await this.$rootScope.organization.toggleAdmin(userId);
    await this.SecurityManager.refreshUser();

    return this.$rootScope.organization;
  }
}
